import http from "@/settings/apiSettings";

// ID-uri fixe seed-uite de /api/Report/SeedPontajReports (vezi PontajReportSeeder.cs)
const STAT_FUNCTII_REPORT_ID = "11111111-1111-1111-1111-111111111105";
const STAT_FUNCTII_DESIGN_ID = "11111111-1111-1111-1111-111111111106";
const SIT_NOMINALA_REPORT_ID = "11111111-1111-1111-1111-111111111107";
const SIT_NOMINALA_DESIGN_ID = "11111111-1111-1111-1111-111111111108";

class RU_RapoarteDataService {
  /** Raport PDF „Stat de funcții" pentru o organigramă (SP RU_StatDeFunctii, @OrganigramaID) */
  raportStatDeFunctii(organigramaId: string): Promise<any> {
    const body = [{ Name: "OrganigramaID", Value: organigramaId, Type: "Guid" }];
    return http.clientRapoarte.post(
      `/Report/GetReport?reportID=${STAT_FUNCTII_REPORT_ID}&reportDesignID=${STAT_FUNCTII_DESIGN_ID}`,
      body,
      { responseType: "blob" }
    );
  }

  /** Raport PDF „Situația Nominală" pentru un detaliu de organigramă (SP RU_SituatiaNominala) */
  raportSituatiaNominala(organigramaDetId: string, data?: string): Promise<any> {
    const d = data ?? new Date().toISOString().slice(0, 10);
    const body = [
      { Name: "Data", Value: d, Type: "DateTime" },
      { Name: "OrganigramaDetID", Value: organigramaDetId, Type: "Guid" },
      { Name: "StructID", Value: "", Type: "Guid" },
    ];
    return http.clientRapoarte.post(
      `/Report/GetReport?reportID=${SIT_NOMINALA_REPORT_ID}&reportDesignID=${SIT_NOMINALA_DESIGN_ID}`,
      body,
      { responseType: "blob" }
    );
  }

  /** Creează/actualizează rapoartele HR în ERP_Reports pentru compania curentă (idempotent) */
  seedRapoarte(): Promise<any> {
    return http.clientRapoarte.post("/Report/SeedPontajReports");
  }
}

export default new RU_RapoarteDataService();
